export default "__VITE_ASSET__DHpkbWQA__"